"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.effects = void 0;
exports.effects = {
    boxShadow: {
        dropShadowSm: '0px 1px 2px 0px rgba(22, 22, 22, 0.34), 0px -1px 1px 0px rgba(22, 22, 22, 0.04)',
        dropShadowMd: '-1px 3px 12px 0px rgba(22, 22, 22, 0.16), 1px 3px 12px 0px rgba(22, 22, 22, 0.16)',
        dropShadowLg: '-5px 7px 20px 0px rgba(22, 22, 22, 0.12), 5px 7px 20px 0px rgba(22, 22, 22, 0.12)',
        dropShadowXl: '-10px 20px 30px 0px rgba(22, 22, 22, 0.12),10px 20px 30px 0px rgba(22, 22, 22, 0.12)',
    },
    opacity: {
        opacity2: 0.2,
        opacity4: 0.4,
        opacity6: 0.6,
        opacity8: 0.8,
    },
};
//# sourceMappingURL=effects.js.map